import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	Typography,
	Box,
	Divider
} from '@mui/material';
import dayjs from 'utils/customDayJS';
import { findUrlInStringAndReturnATagTemplate } from 'utils/generalUtils';

const NoticeDialog = ({ open, notices = [], onClose }) => {
	const formatEffectiveDate = unixTimestamp => {
		if (!unixTimestamp) return '';
		try {
			const localTimezone = dayjs().tz(dayjs.tz.guess()).format('z');
			return `${dayjs(unixTimestamp * 1000).format('MM/DD/YY [at] h:mma')} ${localTimezone}`;
		} catch (error) {
			return unixTimestamp.toString();
		}
	};

	return (
		<Dialog open={open} maxWidth='sm' fullWidth>
			{notices.length > 0 && (
				<>
					<DialogTitle>
						<Typography variant='h5' component='h2'>
							{notices.length === 1 ? 'Notice' : 'Notices'}
						</Typography>
					</DialogTitle>
					<DialogContent>
						{notices.map((notice, index) => (
							<Box key={index}>
								<Typography
									variant='body1'
									sx={{ marginBottom: 1, fontWeight: 'medium', whiteSpace: 'pre-line' }}
									dangerouslySetInnerHTML={{
										__html: findUrlInStringAndReturnATagTemplate(notice.message)
									}}
								></Typography>
								{notice.started_at && (
									<Typography variant='body2' color='textSecondary' sx={{ marginBottom: 2 }}>
										Effective At: {formatEffectiveDate(notice.started_at)}
									</Typography>
								)}
								{index < notices.length - 1 && <Divider sx={{ margin: '16px 0' }} />}
							</Box>
						))}
					</DialogContent>
					<DialogActions>
						<Button onClick={onClose} color='primary' variant='contained'>
							OK
						</Button>
					</DialogActions>
				</>
			)}
		</Dialog>
	);
};

export default NoticeDialog;
